export default __webpack_public_path__ + "static/media/skateboard.312b2543.png";